import * as React from 'react';
import { Toggle, SelectionControlLabel } from '@one-thd/sui-atomic-components';
import { setPurchaserPermissionsToggleAnalytics } from '../../utils/add-manage-user-analytics';
export var UserPermissionsToggle = function (_a) {
    var onChangePermission = _a.onChangePermission, isPermitted = _a.isPermitted;
    var handleChange = function (event) {
        onChangePermission(event.target.checked);
        setPurchaserPermissionsToggleAnalytics(event.target.checked ? 'on' : 'off');
    };
    return (React.createElement("div", { className: "sui-ml-[7px]" },
        React.createElement(SelectionControlLabel, { value: "Allow Purchasers to see all account purchase history", label: "Allow Purchasers to see all account purchase history", className: "sui-flex-row-reverse sui-gap-2" },
            React.createElement("div", { className: "sui-inline sui-mr-[-16px]" },
                React.createElement(Toggle, { checked: !isPermitted, onChange: handleChange, inputAttributes: { 'aria-label': 'controlled' } })))));
};
